import React from 'react';
import { ErrorBoundary } from '@components/common';
import Main from './Main';
import { ManagementProvider } from './store';
import { type ManagementStoreAtom } from './atom';

export type ManagementProps = ManagementStoreAtom;

const Management = (props: ManagementProps) => {
  return (
    <ErrorBoundary>
      <ManagementProvider {...props}>
        <Main />
      </ManagementProvider>
    </ErrorBoundary>
  );
};

export default React.memo(Management);

